import React, { useState } from 'react';
import styles from '../../../styles/common/common-styles.module.scss';
import Button from '../button/Button';
import Warning from '../warning/Warning';
import RadioButtonList from '../radioButtonList/RadioButtonList';
import PrevQuestionLink from '../prevQuestionLink/prevQuestionLink';
import OrganisationWrapped from '../OrganisationWrapped/OrganisationWrapped';
import closeIcon from '../../../../src/assets/images/close-Icon.svg';

const Question2 = props => {
  const [duplicateBusinessFlag, setDuplicateBusinessFlag] = useState(false);

  const isButtonDIsabled = () => {
    if (!props.hasBusiness) {
      return true;
    } else {
      if (props.hasBusiness.value === '2') {
        return props.businessArray.length === 0;
      }
      return false;
    }
  };

  return (
    <div className={`row ${styles.questionWrap}`}>
      <div className={`col`}>
        <PrevQuestionLink
          setCurrentQuestion={props.setCurrentQuestion}
          prevQuestionIndex={1}
        ></PrevQuestionLink>
        <h3 className={`${styles.pageTitle}`}>Did this person own a business in Australia?</h3>
        <p className={styles.questionText}>
          This information will help organisations locate any accounts the person held.
        </p>
        <fieldset className={`nsw-form-fieldset ${styles.nswFormFieldset}`}>
          <RadioButtonList
            list={[
              {
                value: '2',
                label: 'Yes',
                checked: props.hasBusiness && props.hasBusiness.value === '2' ? true : false,
              },
              {
                value: '1',
                label: 'No',
                checked: props.hasBusiness && props.hasBusiness.value === '1' ? true : false,
              },
              {
                value: '0',
                label: 'Unsure',
                checked: props.hasBusiness && props.hasBusiness.value === '0' ? true : false,
              },
            ]}
            id={'deceasedBusiness'}
            name={'deceasedBusiness'}
            displayLayout={'horizontal'}
            className={`nsw-form-radio__input ${styles.nswFormRadio__input}`}
            handleChange={(item, name) => {
              props.setHasBusiness(item);
              if (item.value !== '2') {
                props.setBusinessArray([]);
              } else {
                props.setShowBusinessForm(true);
              }
            }}
          />
        </fieldset>
        {props.hasBusiness?.value === `2` && (
          <div className={`${styles.pageTitle} mt-5 mb-5`}>Business details</div>
        )}

        {props.businessArray?.map((b, i) => (
          <div className={`position-relative ${styles.mobWidth95}`}>
            <Warning
              className={'mb-6'}
              id={'nominationSuccess'}
              type={'success'}
              description={b.businessName}
            />

            <img
              src={closeIcon}
              alt="delete icon"
              className={`${styles.deleteBusiness}`}
              onClick={() => props.deleteBusiness(i)}
            />
          </div>
        ))}

        {props.showBusinessForm && props.hasBusiness?.value === `2` ? (
          <OrganisationWrapped
            regoType={props.regoType}
            setRegoType={props.setRegoType}
            abn={props.abn}
            setAbn={props.setAbn}
            acn={props.acn}
            setAcn={props.setAcn}
            hideTradingNameList={true}
            businessName={props.businessName}
            setBusinessName={props.setBusinessName}
            baseURL={process.env.REACT_APP_BASE_URL}
            selectedTradingName={props.selectedTradingName}
            setSelectedTradingName={props.setSelectedTradingName}
            hideHelpMessage={true}
          />
        ) : null}

        {props.businessArray.length > 0 &&
          props.businessArray.length < 5 &&
          !props.showBusinessForm && (
            <div className={`${styles.addAnotherLabel} flex`} onClick={() => props.addBusiness()}>
              {' '}
              <span>+ Add</span>
            </div>
          )}

        <div className={styles.btnWrap}>
          <Button
            disabled={isButtonDIsabled()}
            onClick={() => {
              props.setCurrentQuestion(3);
            }}
          >
            Next
          </Button>
        </div>
      </div>
    </div>
  );
};

export default Question2;
